import { RequisitionData, RequisitionIncluded, RequisitionItem } from '@type/requisitions.type'
import { getIncludedData } from '@util'

export const statusLabel = (status?: string) => status?.replace(/_/g, ' ') || 'pending review'

/** Items arrive inlined on `attributes.items` on some endpoints and as `included` records on others. */
export const getRequisitionItems = (requisition?: RequisitionData, included: RequisitionIncluded[] = []) => {
  const attributesItems = requisition?.attributes.items
  if (attributesItems?.length) return attributesItems

  const itemRefs = requisition?.relationships?.requisition_items?.data || []

  return itemRefs
    .map(ref => getIncludedData(included, 'requisition_item', ref.id))
    .filter((item): item is RequisitionIncluded => Boolean(item))
    .map(item => {
      const attributes = item.attributes as RequisitionItem
      return {
        id: item.id,
        ...attributes,
        // Some payloads express the product as a relationship instead of an attribute.
        product_id: attributes.product_id ?? item.relationships?.product?.data?.id
      }
    })
}
